import { useState } from 'react';
import classNames from 'classnames';

const useDialogFullScreen = () => {
    const [innerState, setInnerState] = useState(false);

    const getFullScreenState = () => {
        return innerState;
    };

    const setFullScreen = (state: boolean) => {
        setInnerState(state);
    };

    const getDialogClassName = () => {
        const className = 'fx-dialog-full-screen-hooks';

        return classNames(className, {
            'full-screen': getFullScreenState()
        });
    };

    return {
        getFullScreenState,
        getDialogClassName,
        onClick: () => {
            setFullScreen(!getFullScreenState());
        }
    };
};

export default useDialogFullScreen;
